(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

    this.header =
      this.closest('.shopify-section') ||
      this.parentElement ||
      this;

    this.wrapper = this;

    this.stickyType =
      this.getAttribute('data-sticky-type');

    this.headerIsAlwaysSticky =
      this.stickyType === 'always';

    this.headerBounds = {};

    this.currentScrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    this.preventReveal = false;

    if (this.headerIsAlwaysSticky) {

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

      this.header.classList.add(
        'always-fixed'
      );

      this.wrapper.classList.add(
        'is-revealed'
      );
    }

    this.onScrollHandler =
      this.onScroll.bind(this);

    this.hideHeaderOnScrollUp =
      () => this.preventReveal = true;

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      { passive: true }
    );

    this.createObserver();
    this.onScroll();
  }


  disconnectedCallback() {

    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );
  }


  createObserver() {

    let observer =
      new IntersectionObserver(
        (entries, observer) => {

          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();
        }
      );

    observer.observe(this.header);
  }


  onScroll() {

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    const scrollDelta =
      scrollTop - this.currentScrollTop;

    if (scrollTop <= 80) {

      requestAnimationFrame(
        this.reset.bind(this)
      );

    } else if (scrollDelta > 5) {

      if (this.preventHide) return;

      requestAnimationFrame(
        this.hide.bind(this)
      );

    } else if (scrollDelta < -5) {

      requestAnimationFrame(
        this.reveal.bind(this)
      );
    }

    this.currentScrollTop =
      scrollTop;
  }


  hide() {

    if (this.headerIsAlwaysSticky)
      return;

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.wrapper.classList.add(
      'is-hidden'
    );

    this.wrapper.classList.remove(
      'is-revealed'
    );

    this.closeMenuDisclosure();
  }


  reveal() {

    if (this.headerIsAlwaysSticky)
      return;

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );

    this.wrapper.classList.add(
      'is-revealed'
    );

    this.wrapper.classList.remove(
      'is-hidden'
    );
  }


  reset() {

    if (this.headerIsAlwaysSticky)
      return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );

    this.wrapper.classList.remove(
      'is-hidden',
      'is-revealed'
    );
  }


  closeMenuDisclosure() {

    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll(
        'details-disclosure'
      );

    this.disclosures.forEach(
      disclosure => disclosure.close()
    );
  }
}


if (!customElements.get('sticky-header')) {

  customElements.define(
    'sticky-header',
    StickyHeader
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
